import { render, staticRenderFns } from "./DocumentsNewList.vue?vue&type=template&id=60cdb167&scoped=true"
import script from "./DocumentsNewList.vue?vue&type=script&lang=js"
export * from "./DocumentsNewList.vue?vue&type=script&lang=js"
import style0 from "./DocumentsNewList.vue?vue&type=style&index=0&id=60cdb167&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cdb167",
  null
  
)

export default component.exports